export default __webpack_public_path__ + "static/media/lenovo.16868d6b.svg";